import React from 'react';
import cnames from 'classnames';
import PropTypes from 'prop-types';

import './ElidedText.less';

const isFragment = (item) => {
    return React.isValidElement(item) && item.type === React.Fragment;
};

const ElidedText = ({className, children}) => {
    if (!children) {
        return null;
    }

    const wrapContent =
        typeof children === 'string' ||
        React.Children.count(children) !== 1 ||
        isFragment(children);

    const child = wrapContent ? <p>{children}</p> : children;

    const childClassName = child.props.className;
    return React.cloneElement(child, {
        className: cnames(className, childClassName, 'elided-text'),
    });
};

ElidedText.propTypes = {
    className: PropTypes.string,
    children: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.arrayOf(PropTypes.element),
        PropTypes.string,
    ]),
};

export default ElidedText;
